import { render, staticRenderFns } from "./Flavors.vue?vue&type=template&id=4de4446f&"
import script from "./Flavors.vue?vue&type=script&lang=js&"
export * from "./Flavors.vue?vue&type=script&lang=js&"
import style0 from "./Flavors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Flavors.vue"
export default component.exports